import { IOrderStatusCount } from "./../Interface/IOrderStatusCount.interface";

export const OrderStatusCount: IOrderStatusCount = {
    all: 0,
    done: 0,
    kitchen: 0,
    late: 0
};
